// extracted by mini-css-extract-plugin
export default {"modal_header":"ModalHeader_modal_header__qD5or","modal_header__title":"ModalHeader_modal_header__title__mr8E6","modal_header__btn":"ModalHeader_modal_header__btn__ySNMU"};